










import { defineComponent } from "@vue/composition-api";
import { TagInfo } from "@scrile/api-provider/dist/api/TagsProvider";
import BaseCheckbox from "@/components/BaseCheckbox";

export default defineComponent({
  name: "TagItem",
  components: { BaseCheckbox },
  props: {
    tagInfo: { type: Object as () => TagInfo, required: true },
    value: { type: Boolean, default: false },
  },
});
